'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _trip = require('utils/trip');

var _ExpDestinationSelect = require('components/General/ExpDestinationSelect');

var _ExpDestinationSelect2 = _interopRequireDefault(_ExpDestinationSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  DestinationSelect: {
    displayName: 'DestinationSelect'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/DestinationSelect.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var DestinationSelect = _wrapComponent('DestinationSelect')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(DestinationSelect, _Component);

  function DestinationSelect() {
    (0, _classCallCheck3.default)(this, DestinationSelect);
    return (0, _possibleConstructorReturn3.default)(this, (DestinationSelect.__proto__ || (0, _getPrototypeOf2.default)(DestinationSelect)).apply(this, arguments));
  }

  (0, _createClass3.default)(DestinationSelect, [{
    key: 'render',
    value: function render() {
      var destinations = this.props.groupDestinationsByCountry ? (0, _trip.groupDestinationsByCountry)(this.props) : (0, _trip.groupDestinationsByRegion)(this.props);
      if (this.props.locale === 'en') {
        return _react3.default.createElement(_ExpDestinationSelect2.default, this.props);
      }
      return _react3.default.createElement(
        'select',
        (0, _extends3.default)({ onChange: this.props.onSelect }, this.props.fixValue ? { value: '' } : {}),
        _react3.default.createElement(
          'option',
          { value: '' },
          this.props.placeholder
        ),
        (0, _keys2.default)(destinations).map(function (key) {
          return _react3.default.createElement(
            'optgroup',
            { label: key, key: key },
            destinations[key].map(function (city) {
              return _react3.default.createElement(
                'option',
                { key: city.city, value: city.city },
                city.city
              );
            })
          );
        })
      );
    }
  }]);
  return DestinationSelect;
}(_react2.Component), _class.propTypes = {
  locale: _react2.PropTypes.string,
  placeholder: _react2.PropTypes.string,
  destinations: _react2.PropTypes.array,
  onSelect: _react2.PropTypes.func,
  groupDestinationsByCountry: _react2.PropTypes.bool,
  fixValue: _react2.PropTypes.bool,
  messages: _react2.PropTypes.object
}, _class.defaultProps = {
  groupDestinationsByCountry: false,
  locale: 'en'
}, _temp));

exports.default = DestinationSelect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/DestinationSelect.js
// module id = 317
// module chunks = 47